import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../context/AuthContext'
import { useLocation, NavLink, Link } from 'react-router-dom'

import {
  Content,
  Header,
  HeaderMenuButton,
  HeaderName,
  HeaderNavigation,
  HeaderMenu,
  HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderPanel,
  HeaderSideNavItems,
  SideNavItems,
  SkipToContent,
  Switcher,
  SwitcherDivider,
  SwitcherItem,
  SideNav,
  Tag,
} from 'carbon-components-react';
import { Search20, Notification20, AppSwitcher20 } from '@carbon/icons-react';

const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, REACT_APP_DEV_MEDIA_URL, REACT_APP_PROD_MEDIA_URL, NODE_ENV } = process.env;
const API_URL =
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;
const MEDIA_URL =
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_MEDIA_URL : process.env.REACT_APP_DEV_MEDIA_URL;

const HeaderComp = () => {
  let { user, logoutUser, authTokens } = useContext(AuthContext)
  let profileId = user?.id
  let [profile, setProfile] = useState(null)
  let [userPic, setUserPic] = useState(null)
  let [mounted, setMounted] = useState(false)
  let [isSideNavExpanded, setSideNavExpanded] = useState(false)
  let [switcherState, setSwitcherState] = useState(false)

  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  useEffect(() => {
    if (user) {
      getProfile()
      getUserPic()
      setMounted(true)
    }

  }, [profileId])

  let getProfile = async () => {
    if (!user) {
      //Don't send fetch
    } else {
      let response = await fetch(`${API_URL}/profile/${profileId}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authTokens?.access
        }
      })
      let data = await response.json()
      setProfile(data)
    }
  }

  let getUserPic = async () => {
    if (!user) {
      //Don't send fetch
    } else {
      let response = await fetch(`${API_URL}/userpic/${profileId}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authTokens?.access
        }
      })
      let data = await response.json()
      setUserPic(data)
    }
  }

  let onClickSideNavExpand = () => {
    if (isSideNavExpanded === true) {
      setSideNavExpanded(false)
    } else {
      setSideNavExpanded(true)
    }
  }

  let onClickSwitcherState = () => {
    if (switcherState === true) {
      setSwitcherState(false)
    } else {
      setSwitcherState(true)
    }
  }

  return (<>
    {mounted ?
      user ?
        <Header aria-label="Willow BMS Name">
          <SkipToContent />
          <HeaderMenuButton
            aria-label="Open menu"
            onClick={onClickSideNavExpand}
            isActive={isSideNavExpanded}
          />
          <HeaderName href="/" prefix="Willow">
            [BMS]
          </HeaderName>
          {splitLocation[1] != "system" ?
            <HeaderNavigation aria-label="Willow [BMS]">
              <HeaderMenuItem aria-label="Home" href="/">Home</HeaderMenuItem>
              <HeaderMenuItem aria-label="Agreements" href="/agreements">Agreements</HeaderMenuItem>
              <HeaderMenuItem aria-label="Submissions" href="/submissions">Submissions</HeaderMenuItem>
            </HeaderNavigation>
            :
            <HeaderNavigation aria-label="Willow [BMS]">
              <HeaderMenu aria-label="Settings" menuLinkName="System">
                <HeaderMenuItem href="/system/settings/general">General</HeaderMenuItem>
                <HeaderMenuItem href="/system/settings/company">Company Information</HeaderMenuItem>
                <HeaderMenuItem href="/system/settings/email">Email (SMTP)</HeaderMenuItem>
                <HeaderMenuItem href="/system/settings/email/flpts">FLPTS Email Settings</HeaderMenuItem>
              </HeaderMenu>
              <HeaderMenu aria-label="Reference Data" menuLinkName="Reference Data">
                <HeaderMenuItem href="/system/settings/reference-data/geographical/countries">Countries</HeaderMenuItem>
                <HeaderMenuItem href="/system/settings/reference-data/geographical/provinces">Provinces</HeaderMenuItem>
                <HeaderMenuItem href="/system/settings/reference-data/geographical/counties">Counties</HeaderMenuItem>
              </HeaderMenu>
            </HeaderNavigation>
          }

          <HeaderGlobalBar>
            <HeaderGlobalAction
              aria-label="Settings Menu"
              onClick={onClickSwitcherState}
              tooltipAlignment="end">
              <AppSwitcher20 />
            </HeaderGlobalAction>
          </HeaderGlobalBar>
          <HeaderPanel aria-label="Header Panel" expanded={switcherState}>
            <Switcher aria-label="Settings Menu Container">
              <SwitcherDivider />
              <SwitcherItem href="/" aria-label="BMS">
                BMS
              </SwitcherItem>
              <SwitcherItem href="/system/settings/general" aria-label="System Settings">
                System Settings
              </SwitcherItem>
              <SwitcherDivider />
              <SwitcherItem onClick={logoutUser} aria-label="Log Out">
                Log Out
              </SwitcherItem>
            </Switcher>
          </HeaderPanel>
          <SideNav
            aria-label="Side navigation"
            expanded={isSideNavExpanded}
            isPersistent={false}>
            <SideNavItems>
              {splitLocation[1] != "system" ?
                <HeaderSideNavItems>
                  <HeaderMenuItem aria-label="Home" href="/">Home</HeaderMenuItem>
                  <HeaderMenuItem aria-label="Agreements" href="/agreements">Agreements</HeaderMenuItem>
                  <HeaderMenuItem aria-label="Submissions" href="/submissions">Submissions</HeaderMenuItem>
                </HeaderSideNavItems>
                :
                <HeaderSideNavItems>
                  <HeaderMenu aria-label="Settings" menuLinkName="System">
                    <HeaderMenuItem href="/system/settings/general">General</HeaderMenuItem>
                    <HeaderMenuItem href="/system/settings/company">Company Information</HeaderMenuItem>
                    <HeaderMenuItem href="/system/settings/email">Email (SMTP)</HeaderMenuItem>
                    <HeaderMenuItem href="/system/settings/email/flpts">FLPTS Email Settings</HeaderMenuItem>
                  </HeaderMenu>
                  <HeaderMenu aria-label="Reference Data" menuLinkName="Reference Data">
                    <HeaderMenuItem href="/system/settings/reference-data/geographical/countries">Countries</HeaderMenuItem>
                    <HeaderMenuItem href="/system/settings/reference-data/geographical/provinces">Provinces</HeaderMenuItem>
                    <HeaderMenuItem href="/system/settings/reference-data/geographical/counties">Counties</HeaderMenuItem>
                  </HeaderMenu>
                </HeaderSideNavItems>
              }
            </SideNavItems>
          </SideNav>
        </Header>
        : <></> : <></>
    }
  </>
  )
}

export default HeaderComp